
import { defineComponent } from 'vue';
// import { CheckOutlined, EditOutlined } from '@ant-design/icons-vue';
import moment from 'moment';
import numeral from 'numeral';
import groupBy from 'lodash.groupby';
import { getOrderList, modifyOrder } from '@/api/apis';
import { dollarCode } from '@/utils/constants';

interface PartOrderProps {
  dataSource: any[];
  moneyTypeList: any[];
  groupedDataSource: any;
  [key: string]: any;
}

export default defineComponent({
  name: 'PartOrder',
  components: {
    // CheckOutlined,
    // EditOutlined
  },
  props: {
    moneyTypes: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data(): PartOrderProps {
    return {
      moment,
      numeral,
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      queryParam: {
        consignee: '',
        orderNo: '',
        dateRange: []
      },
      loading: false,
      colTitle: [
        'order_no',
        'order_consignee',
        'order_date',
        'unit',
        'quantity',
        'total_price',
        'status',
        'consignee',
        'remark',
        'logistics'
      ],
      columns: [
        {
          dataIndex: 'orderNum',
          width: 100,
          slots: { customRender: 'order-no', title: 'order_no-title' }
        },
        {
          dataIndex: 'consignee',
          width: 120,
          slots: { title: 'order_consignee-title' }
        },
        {
          dataIndex: 'createTime',
          width: 100,
          slots: { customRender: 'order-date', title: 'order_date-title' }
        },
        {
          dataIndex: 'unit',
          width: 100,
          slots: { customRender: 'unit', title: 'unit-title' }
        },
        {
          dataIndex: 'totalQuantity',
          width: 100,
          slots: { customRender: 'totalQuantity', title: 'quantity-title' }
        },
        {
          dataIndex: 'totalPrice',
          width: 100,
          slots: { customRender: 'totalPrice', title: 'total_price-title' }
        },
        {
          dataIndex: 'orderStatus',
          width: 100,
          slots: { customRender: 'orderStatus', title: 'status-title' }
        },
        // {
        //   width: 100,
        //   slots: { customRender: 'logistics', title: 'logistics-title' }
        // },
        {
          width: 120,
          dataIndex: 'remark',
          slots: { title: 'remark-title' }
        }
      ],
      ipagination: {
        current: 1,
        pageSizeOptions: ['5', '10', '15'],
        total: 0,
        showSizeChanger: true,
        pageSize: 5,
        showQuickJumper: true
        // size: 'large'
      },
      dataSource: [],

      // total price
      moneyTypeList: [],
      groupedDataSource: {}
    };
  },
  // computed: {
  //   totalSummary() {
  //     let res = numeral(0);

  //     this.dataSource.forEach(d => {
  //       res = res.add(d.totalSellingPrice || 0);
  //     });

  //     return res.format('$0,0.00');
  //   }
  // },
  created() {
    this.loadData();
  },
  methods: {
    getTotalSummary(moneyType) {
      let res = numeral(0);

      this.dataSource
        .filter(s => s.moneyType === moneyType)
        .forEach(d => {
          res = res.add(d.totalSellingPrice || 0);
        });

      return this.$t(moneyType) + res.format('0,0.00');
    },
    getTotalPrice(record) {
      const res = numeral(0);

      record.offSellingPrice
        ? res.add(record.offSellingPrice || 0)
        : res.add(record.totalSellingPrice || 0);
      const currency = this.getCurrency(record);

      const value = res.value();
      return value ? currency + res.format('0,0.00') : '';
    },
    // called from parent
    getFilter() {
      return {
        startTime:
          this.queryParam.dateRange.length > 0
            ? moment(this.queryParam.dateRange[0]).format('YYYY-MM-DD')
            : '',
        endTime:
          this.queryParam.dateRange.length > 0
            ? moment(this.queryParam.dateRange[1]).format('YYYY-MM-DD')
            : '',
        orderNum: this.queryParam.orderNo,
        consignee: this.queryParam.consignee
      };
    },
    getCurrency(record) {
      let res = '';
      const moneyType = record.moneyType;

      if (moneyType) {
        const item: any = this.moneyTypes.find(
          (s: any) => s.code === moneyType
        );

        res = item ? item.val : '';
      }
      return res;
    },
    getOrderStatus(status) {
      let res = '';

      if (!isNaN(status) && status !== null && status >= 0) {
        res = this.$t(`order_status.${status}`);
      }
      return res;
    },
    goToLogDetail(record) {
      this.$router.push(
        `/part-logistics-info/${record.id}?orderNo=${record.orderNum}`
      );
    },
    goToDetail(record) {
      this.$router.push(`/part-order-detail/${record.id}`);
    },
    async loadData() {
      this.loading = true;

      const res = await getOrderList({
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        orderType: 2, // 配件
        startTime:
          this.queryParam.dateRange.length > 0
            ? moment(this.queryParam.dateRange[0]).format('YYYY-MM-DD')
            : null,
        endTime:
          this.queryParam.dateRange.length > 0
            ? moment(this.queryParam.dateRange[1]).format('YYYY-MM-DD')
            : null,
        orderNum: this.queryParam.orderNo,
        consignee: this.queryParam.consignee
      });

      if (res.success) {
        this.ipagination.total = res.result.total;
        this.dataSource = res.result.records || [];

        this.dataSource.forEach(d => {
          if (!d.moneyType) {
            d.moneyType = dollarCode;
          }
        });

        const groupedData = groupBy(this.dataSource, d => d.moneyType);

        this.groupedDataSource = Object.keys(groupedData);
      }

      this.loading = false;
    },
    onShowSizeChange(current) {
      this.ipagination.current = current;

      this.loadData();
    },
    onChange(page, pageSize) {
      this.ipagination.current = page;
      this.ipagination.pageSize = pageSize;

      this.loadData();
    },
    async handleSave(record) {
      const res = await modifyOrder({
        ...record
      });

      if (res.success) {
        record.editable = false;
      }
    },
    handleEdit(record) {
      record.editable = true;
    },
    handleSearch() {
      this.ipagination.current = 1;
      this.loadData();
    },
    handleReset() {
      this.queryParam = {
        consignee: '',
        orderNo: '',
        dateRange: []
      };

      this.loadData();
    }
  }
});
